import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

import { PagedResponse, ActivityPdfTemplate, ActivityPdfTemplateSearchRequest } from '@core/api';

@Injectable({
  providedIn: 'root'
})
export class ActivityPdfTemplateService {
  constructor(private http: HttpClient) { }

  search(request: ActivityPdfTemplateSearchRequest): Observable<PagedResponse<ActivityPdfTemplate>> {
    return this.http.post<PagedResponse<ActivityPdfTemplate>>(environment.apiUrl + '/api/ActivityPdfTemplate/Search', request);
  }
}
